import { ReactNode, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { useAuthStatusWriter } from 'app/railways/domains/auth/features/auth-status';
import { useAuthCheck } from 'app/railways/domains/auth/features/check-auth';
import { useUserProfileStore } from 'app/railways/domains/profile/features/user-profile-data';
import { Loading } from 'app/ui';

type CheckAuthProps = {
  children: ReactNode | ReactNode[];
  login: ReactNode;
};

export const CheckAuth = observer(({ login, children }: CheckAuthProps) => {
  const userProfileStore = useUserProfileStore();
  const authStatusStore = useAuthStatusWriter();
  const authCheck = useAuthCheck({
    userProfileStore,
    authStatusStore,
  });

  useEffect(() => {
    authCheck.fetchProfile();
  }, []);

  switch (authCheck.status.get()) {
    case 'idle':
    case 'loading':
      return (
        <div
          style={{
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Loading active/>
        </div>
      );
    case 'error':
      return <div>Ошибка: {authCheck.error.get()}</div>;
    case 'unauthorized':
      return <>{login}</>;
    case 'granted':
      return <>{children}</>;
    default:
      return <div>CheckUser: Неверное состояние приложения</div>;
  }
});
